// 首页
import axios from '@/libs/api.request'

// 首页文档总数
export const commonPublicAchieveCount = (data) => {
  return axios.request({
    data: data,
    url: '/api/commonPublicAchieve/CommonPublicAchieve/count',
    method: 'post'
  })
}

// 隐患类别统计表
export const getNonstandardCount = (data) => {
  return axios.request({
    data: data,
    url: '/api/project/nonstandard/getNonstandardCount',
    method: 'post'
  })
}

// 获取通知公告
export const GetNotice = (data) => {
  return axios.request({
    data: data,
    url: '/api/project/PjNotice/listByPageByNotice',
    method: 'post'
  })
}

// 获取通讯录
export const GetProjectInfoPeople = (data) => {
  return axios.request({
    data: data,
    url: '/api/project/PjProjectInfoPeople/listByPageByProjectInfoPeople',
    method: 'post'
  })
}

// 获取待办数量
export const GetmyPendingReview = (data) => {
  return axios.request({
    data: data,
    url: '/process_api/bpm/process/ins/myPendingReview',
    method: 'post'
  })
}

// 单点登录
export const xyycplogin = (data) => {
  return axios.request({
    data: data,
    url: `/api/auth/xyycplogin`,
    method: 'post'
  })
}

// 获取统计图表数据
export const GetChartData3 = (data) => {
  return axios.request({
    data: data,
    url: '/api/nondestructiveTesting/AutPositionCount/queryAutPositionCount3',
    method: 'post'
  })
}

// 获取项目周月报
export const GetProjectReports = (data) => {
  return axios.request({
    data: data,
    url: '/api/project/scheduleManagement/selectByData',
    method: 'post'
  })
}
